import { reactive } from 'vue';
import apiInstance from '@/axios';
import { supportAccessOn } from '@/utils/supportEntry';
import { accessFromIntrospect } from '@/utils/access';
import { getAccessToken } from '@/utils/tokenStore';

/**
 * supportAccess 스위치 상태(GET /auth/introspect 의 modes). on=false 면 고객 상세·목록이 main 과 같은 옛 버튼만 보인다.
 * 같은 답에서 내 권한·담당 고객사(myAccess)도 뽑는다 — 메뉴·버튼 숨김용(11-02 리셀러 직원).
 * ponytail: 로그인 토큰마다 한 번만 읽음 — 스위치·권한을 바꾸면 새로 고쳐야 반영(서버는 바로 막음)
 */
export const supportAccessState = reactive({ on: false });
export const myAccess = reactive(accessFromIntrospect(null));
let loading = null;
let loadedFor = null;
export const loadSupportAccess = () => {
  const token = getAccessToken();
  if (!loading || loadedFor !== token) {
    loadedFor = token;
    // 다른 계정으로 다시 로그인했는데 읽기가 실패하면 앞 계정 값이 남지 않게 먼저 비움(모름 = 서버가 막음)
    Object.assign(myAccess, accessFromIntrospect(null));
    loading = apiInstance
      .get('/auth/introspect', { showErrorNotice: false })
      .then(({ data }) => {
        supportAccessState.on = supportAccessOn(data);
        Object.assign(myAccess, accessFromIntrospect(data));
      })
      .catch(() => undefined);
  }
  return loading;
};
